import { render } from "./YourPizzaProfile.vue?vue&type=template&id=8de3d764"
import script from "./YourPizzaProfile.vue?vue&type=script&lang=js"
export * from "./YourPizzaProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__